import { render } from "./MobileApp.vue?vue&type=template&id=27cd8722"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__